import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import FileSaver from 'file-saver';
import { MessageService } from 'primeng';
import { EditService } from './edit.service';
import { ITradePlateFilter } from '../interfaces/trade-plate-filter';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { Message } from '../classes/Message';
import { TaggedLogger } from './taggedLogger';
import { LoggerService } from './logger.service';
import moment from 'moment';

@Injectable({ providedIn: 'root' })
export class TradePlateService extends EditService<any, any> {
  private readonly logger: TaggedLogger;

  url = '/api/tradeplate';
  entityTitle = 'Trade Plate';

  constructor(
    private messageService: MessageService,
    http: HttpClient,
    handlersFactory: HttpResponsesHandlersFactory,
    loggerService: LoggerService,
  ) {
    super(http, handlersFactory);
    this.logger = loggerService.taggedLogger('service:trade-plate');
  }

  public save(item: any): Promise<any> {
    return this.handleRequest(
      this.http.post(`${this.url}`, item),
      this.handlersFactory.getForCreate(this.entityTitle),
    ).then(this.extractData);
  }

  public enableDisable(item: any): Promise<any> {
    return this.handleRequest(
      this.http.post(`${this.url}/enableDisable`, item),
      this.handlersFactory.getForUpdate(this.entityTitle),
    ).then(this.extractData);
  }

  public unallocate(item: any): Promise<any> {
    return this.handleRequest(
      this.http.post(`${this.url}/unallocate`, item),
      this.handlersFactory.getForUpdate(this.entityTitle),
    ).then(this.extractData);
  }

  /**
   * Downloads the currently active filtered as a CSV
   * @params:
   */
  downloadToCSV(filter: ITradePlateFilter = null) {
    const filename = `TradePlate_${moment().format('YYYYMMMMDo_h:mm')}.csv`;

    const params = this.constructHttpParams(filter);
    const report = this.http.get(`${this.url}/downloadToCSV`, {
      params: params,
      responseType: 'blob',
    });

    report.subscribe(
      (x) => {
        this.logger.debug('Got data to export as CSV.');
        TradePlateService.handleDownloadFile(x, filename);
      },
      (error) => {
        this.logger.error('Could not download CSV', error);
        this.messageService.add(Message.Error('Could not download CSV'));
      },
      () => {
        this.messageService.add(Message.Success('Downloaded successful'));
      },
    );

    return report;
  }

  private static handleDownloadFile(blob, filename) {
    FileSaver.saveAs(blob, filename);
  }
}
